import {RailsApi} from '@/api/rails.api.js'
import {Channel} from '@/models/channel.model.js'

/**
 * My channels API service
 */
export class MyChannelsApi extends RailsApi {

  //Props
  basePath = '/my_channels'
  itemKey = 'channel'
  itemsKey = 'channels'
  ModelClass = Channel
}

//Export singleton instance
export const myChannelsApi = new MyChannelsApi()
